// PricingPage.jsx
import { useEffect, useState } from "react";
import pricingPlans from "../sections/pricing_component/pricing";
import PricingRow from "../sections/pricing_component/PricicngRow";
import Footer from "../sections/web_core/Footer";
import SecondHeroSection from "../sections/web_core/SecondHeroSection";
import FeaturesSection from "../sections/web_core/FeatureSection";
import IMAGE_1 from "../Assets/Courses/imgi_25_page-title.jpg";

/* =========================
   Section Wrapper
========================= */
const SectionWrapper = ({ children, className = "" }) => {
  return <section className={`w-full mb-[5px] ${className}`}>{children}</section>;
};

const CURRENCY_MAP = { US: "USD", GB: "GBP", CA: "CAD" };

const Pricing = () => {
  const [currency, setCurrency] = useState("USD");
  const [rates, setRates] = useState({ USD: 1 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const geoRes = await fetch("https://ipapi.co/json/");
        const geoData = await geoRes.json();
        const detectedCurrency = CURRENCY_MAP[geoData.country_code] || "USD";
        setCurrency(detectedCurrency);

        const rateRes = await fetch("https://open.er-api.com/v6/latest/USD");
        const rateData = await rateRes.json();
        setRates(rateData.rates);
      } catch (error) {
        console.error("Pricing detection failed", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPricingData();
  }, []);

  const convertedPlans = pricingPlans.map((plan) => ({
    ...plan,
    price: Math.round(plan.price * (rates[currency] || 1)),
    currencySymbol: currency === "GBP" ? "£" : "$",
    currencyLabel: currency,
  }));

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-white">
        <div className="w-12 h-12 border-4 border-green-900 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50/50">

      {/* Hero Section */}
      <SectionWrapper>
        <SecondHeroSection
          title="Plans & Pricing"
          subtitle="Transparent pricing for professional growth"
          bgImage={IMAGE_1}
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "Pricing" },
          ]}
        />
      </SectionWrapper>

      {/* Pricing Row */}
      <SectionWrapper className="max-w-7xl mx-auto px-4 py-16">
        <PricingRow plans={convertedPlans} />
      </SectionWrapper>

      {/* Features Section */}
      <SectionWrapper className="max-w-7xl mx-auto px-4">
        <FeaturesSection />
      </SectionWrapper>

      <Footer />
    </div>
  );
};

export default Pricing;